import Chart from 'chart.js/auto';

const pending = new Set();
const renderAllPending = () => [...pending].forEach((loader) => loader.renderNow());
// Print and BrowserCapture screenshots snapshot before any observer fires, so build everything on demand.
window.addEventListener('beforeprint', renderAllPending);
window.addEventListener('charts:render-all', renderAllPending);

export default class ChartLazyLoader {
  /**
   * @param {HTMLCanvasElement} canvas
   * @param {Function} createChartCallback – should create the Chart on this canvas
   * @param {IntersectionObserverInit} [ioOptions={ rootMargin: '200px', threshold: 0 }]
   */
  constructor(canvas, createChartCallback, ioOptions = { rootMargin: '200px', threshold: 0 }) {
    this.canvas = canvas;
    this.createChart = createChartCallback;
    this.ioOptions = ioOptions;
    this.observer = null;

    this._init();
  }

  _init() {
    pending.add(this);
    // Also fires when a display:none ancestor (tab, modal, accordion) is revealed.
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this._renderIfNeeded();
          this.disconnect();
        }
      });
    }, this.ioOptions);

    this.observer.observe(this.canvas);
  }

  renderNow() {
    if (!this.canvas.getClientRects().length) return;

    this.disconnect();
    this._renderIfNeeded();
    const chart = Chart.getChart(this.canvas);
    chart?.stop();
    chart?.update('none');
  }

  _renderIfNeeded() {
    if (!Chart.getChart(this.canvas)) {
      this.createChart();
    }
  }

  disconnect() {
    pending.delete(this);
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }
}
